<template>
    <v-modal-slot id="change-expedient-contract-type-modal"
                  @accepted="emitContractTypeChanged">
        <template v-slot:modal-title>
            Cambiar tipo de contrato
        </template>

        <template v-slot:modal-content>
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label class="form-label">Tipo de contrato: </label>

                        <select class="form-select" aria-label="Tipo de contrato" v-model="selected_contract_type">
                            <option :value="contract_type.key" :key="contract_type.id" v-for="contract_type in contractTypes">
                                {{ contract_type.value }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </template>

        <template v-slot:accept-button>
            Guardar
        </template>

        <template v-slot:close-button>
            Cerrar
        </template>
    </v-modal-slot>
</template>

<script>
import {getContractTypes} from "../../../../helpers/requests/RequestsExpedients";
import VModalSlot from "../../../general/VModalSlot";

export default {
    name: "ExpedientDetailChangeContractTypeModal",
    components: {
        VModalSlot
    },
    data() {
        return {
            selected_contract_type: '',
            contractTypes: [],
        }
    },
    props: {
        contractType: {
            type: String,
            required: false,
        }
    },
    async mounted() {
        await this.loadContractTypeOptions();

        this.selected_contract_type = this.contractType;
    },
    methods: {
        async loadContractTypeOptions() {
            this.contractTypes = await getContractTypes();
        },
        emitContractTypeChanged() {
            this.$emit('contract-type-changed', this.selected_contract_type);
        },
    },
}
</script>
